$(function () {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul li');
    var nav_align = 'right';
    var break_point = 1200;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
        nav_wrap.find('.menu-item-is-megamenu').removeClass('__active');
        $('.burgerText').text('Menu')
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
        $('.burgerText').text('Close')
    };

    // nav dropdown on focus/keyboard navigation
    if (browser_width >= break_point) {
        $('.menu-item').focusin(function () {
            $(this).addClass('__active');
             $(this).children('button').attr('aria-expanded', true);
        }).focusout(function () {
            $(this).removeClass('__active');
             $(this).children('button').attr('aria-expanded', false);
        }).mouseenter(function () {
            $(this).addClass('__active');
             $(this).children('button').attr('aria-expanded', true);
        }).mouseleave(function () {
            $(this).removeClass('__active');
             $(this).children('button').attr('aria-expanded', false);
        });

        // add blur when root level menu item selected
        $('.header-main .nav>ul>li.menu-item:not(.search)').focusin(function () {
            $('body').addClass('__blur');
        }).focusout(function () {
            $('body').removeClass('__blur');
        }).mouseenter(function () {
            $('body').addClass('__blur');
        }).mouseleave(function () {
            $('body').removeClass('__blur');
        });
    }

    if (browser_width < break_point) {
        nav_trigger.click(function (event) {
            event.stopPropagation();
            if ($(this).children('ul').length > 0) {
                $(this)
                    .parents('ul')
                    .removeClass('__active');
                $(this)
                    .children('ul')
                    .addClass('__active');
            }
            if ($(this).children('.menu-item-is-megamenu').length > 0) {
                $(this)
                    .parents('ul')
                    .removeClass('__active');
                $(this)
                    .children('.menu-item-is-megamenu')
                    .addClass('__active');
            }
        });

        $('.menu-item-has-children > a').click(function(event) {
            event.preventDefault();
        });
    }

    var nav_ul = $('.nav ul li > ul');
    var megamenu = $('.nav ul li > .menu-item-is-megamenu');
    var view_button = $('<li class="viewall menu-item"><a href="#">View</a></li>');
    var back_button = $('<li class="backto"><button>Back</button></li>');

    if (browser_width < break_point) {
        nav_ul.prepend(view_button);
        nav_ul.prepend(back_button);
        // Same but in divs for megamenu
        megamenu.prepend($('<div class="viewall"><a href="#">View</a></div>'));
        megamenu.prepend($('<div class="backto"><button>Back</button></div>'));
    }

    var back_menu = $('.backto');
    back_menu.click(function (event) {
        event.preventDefault();
        event.stopPropagation();
        if ($(this).parent('.menu-item-is-megamenu').length > 0) {
            $(this)
            .parent('.menu-item-is-megamenu')
            .removeClass('__active');
            $(this)
                .parents('li')
                .parent('ul')
                .addClass('__active');
        } else {
            $(this)
            .parent('ul')
            .removeClass('__active');
            $(this)
                .parents('li')
                .parent('ul')
                .addClass('__active');
        }
    });

    // Touch device check
    const isTouchDevice = () => {
        return window.matchMedia("(pointer: coarse)").matches
    }
    // If desktop and touch device, disable link click and add extra view link
    if (browser_width > break_point && isTouchDevice()) {
        nav_trigger.click(function (event) {
            event.stopPropagation();
            if ($(this).children('ul').length > 0) {
                event.preventDefault();
            }
        });
        nav_ul.prepend(view_button);
    }

    var view_all = $('.viewall');
    view_all.each(function () {
        var parent = $(this).closest('ul').siblings()
        if (typeof parent.attr('href') !== typeof undefined && parent.attr('href') !== false) {
            var parent_url = parent.attr('href');
            var parent_title = parent.html();
            $(this).find('a').attr('href', parent_url);
            $(this).find('a').html(parent_title);
        } else {
            view_all.remove();
        }
    });

    view_all.click(function (event) {
        event.stopPropagation();
    });

});